const personalFields = [
	{
		name: 'vorname',
		label: 'Vorname',
		type: 'text',
		required: true,
		value: '',
	},
	{
		name: 'nachname',
		label: 'Nachname',
		type: 'text',
		required: true,
		value: '',
	},
	{
		name: 'unternehmen',
		label: 'Unternehmen',
		type: 'text',
		required: false,
		value: '',
	},
	{
		name: 'anschrift',
		label: 'Anschrift',
		type: 'text',
		required: true,
		value: '',
	},
	{
		name: 'ort',
		label: 'Ort',
		type: 'text',
		required: true,
		value: '',
	},
	{
		name: 'postleitzahl',
		label: 'Postleitzahl',
		type: 'text',
		required: true,
		value: '',
	},
	{
		name: 'email',
		label: 'E-Mail-Adresse',
		type: 'email',
		required: true,
		value: '',
	},
	{
		name: 'telefon',
		label: 'Telefon',
		type: 'tel',
		required: true,
		value: '',
	},
];

export { personalFields };
